import { render, staticRenderFns } from "./InboxFilterIssueStatus.vue?vue&type=template&id=9e44faf6"
import script from "./InboxFilterIssueStatus.vue?vue&type=script&lang=js"
export * from "./InboxFilterIssueStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports